import axios from "axios";
import { jsPDF } from "jspdf";
import * as XLSX from "xlsx";
import { getItem, getItemToken } from "../../Utils/localStorageUtils";
import { t } from "i18next";

import { toast } from 'react-toastify';

const URLGenerater = (URLNAME) => {
    if (URLNAME === 'analytics_trending_now') return 'trending-now';
    return URLNAME?.replace(/ /g, '-')?.replace(/_/g, '-').toLowerCase();
}
const URLDashRemover = (URLNAME) => {
    return capitalizeFirstLetter(URLNAME.replace(/[-_]/g, ' '));
}

const getSourceFromURL = (slug) => {
    if (!slug) return '';
    const mappings = {
        'continue-watching': 'continue_watching',
        'featured-series': 'featured_series',
        'latest-series': 'latest_series',
        'scheduled-publish-livestream': 'scheduled_publish_LiveStream',
        'scheduled-publish-video': 'scheduled_publish_video',
        'artists': 'Artists',
        'featured-audios': 'featured_audios',
        'featured-livestreams': 'featured_livestreams',
        'livestream-videos': 'livestream_videos',
        'audio-albums': 'Audio_Albums',
        'alllanguage': 'AllLanguage',
        'languages': 'languages',
        'latest-videos': 'latest_videos',
        'featured-videos': 'featured_videos',
        'video-schedule': 'video_schedule',
        'radio-station': 'radio_station',
        'vertical-shorts': 'vertical_shorts',
        'horizontal-shorts': 'horizontal_shorts',
        'trending-series': 'trending_series',
        'trending-videos': 'trending_videos',
        'recommended-videos-site': 'Recommended_videos_site',
        'recommended-videos-users': 'Recommended_videos_users',
        'recommended-videos-country': 'Recommended_videos_Country',
        'top-ten-videos': 'Top_Ten_Videos',
        'latest-viewed-videos': 'latest_viewed_Videos',
        'latest-viewed-livestream': 'latest_viewed_Livestream',
        'latest-viewed-episode': 'latest_viewed_Episode',
        'latest-viewed-audios': 'latest_viewed_Audios',
        'analytics-trending-now': 'analytics_trending_now',
        'trending-now': 'analytics_trending_now',
        'audios': 'audios'
    };
    return mappings[slug] || slug.replace(/-/g, '_');
}


const formatDuration = (duration) => {
    const parts = duration.split(':');
    if (parts.length === 3) {
        const [hours, minutes, seconds] = parts;
        if (parseInt(hours, 10) > 0) {
            return `${hours}:${minutes}:${seconds}`;
        } else {
            return `${minutes}:${seconds}`;
        }
    }
    return duration;
};

const calculateTotalTime = (data) => {
    if (!data) return;

    const [hours, minutes, seconds] = data.split(':').map(Number);

    let formattedTime = '';
    if (hours > 0 && hours !== undefined) {
        formattedTime += `${hours}h `;
    }
    if (minutes > 0 || (hours > 0 && minutes !== undefined)) {
        formattedTime += `${minutes}m`;
    }
    if (seconds > 0 && seconds !== undefined) {
        formattedTime += ` ${seconds}s`;
    }

    return formattedTime.trim()
};


// const LogOut = (PATH) => {
//     setTimeout(() => {
//         localStorage.clear();
//         window.location.href = PATH;
//     }, 1000);
// }

function LogOut(PATH) {
    localStorage.removeItem('expires_in');
    localStorage.removeItem('loginTime');
    localStorage.clear();
    window.location.href = PATH || '/';
}

function checkLogout() {
    const expiresInSeconds = parseInt(localStorage.getItem('expires_in'), 10);
    const loginTime = localStorage.getItem('loginTime');

    // Need both values to compute expiry
    if (!expiresInSeconds || !loginTime) return;

    const loginTimestamp = new Date(loginTime).getTime(); // ms
    const expiryTimestamp = loginTimestamp + expiresInSeconds * 1000; // ms

    if (Date.now() >= expiryTimestamp) {
        LogOut('/'); // Logout if expiry time has passed
    }
}

// Check every 5 minutes — frequent enough to catch expiry without hammering the browser
setInterval(checkLogout, 1000 * 60 * 5);

const capsFirstLetter = (str) => {
    return str?.charAt(0).toUpperCase() + str?.slice(1);
};
const capitalizeFirstLetter = (str) => {
    return str?.split(' ').map(word => word?.charAt(0).toUpperCase() + word?.slice(1)).join(' ');
};

// const LikeAction = async (userId, userType, deviceType, sourceId, sourceType, status, accessHeader) => {

//     return axios.post(`${process.env.REACT_APP_Baseurl}/Front-End/Like-Update`, {
//         Login_user_type: userType,
//         Login_user_id: userId,
//         Login_device_type: deviceType,
//         source_id: sourceId,
//         source_type: sourceType,
//         like_status: status,
//     }, {
//         headers: getItemToken('access_token') || {
//             'guestverfiykey': "WebVodWebnexs",
//             'Content-Type': 'application/json',
//         }
//     }).then(response => {
//         return response?.data;
//     }).catch(err => {
//         const errorMessage = err.response?.data?.message || 'An error occurred';
//     });
// };

// const disLikeAction = async (userId, userType, deviceType, sourceId, sourceType, status) => {
//     try {
//         const response = await axios.post(`${process.env.REACT_APP_Baseurl}/Front-End/Dislike-Update`, {
//             Login_user_type: userType,
//             Login_user_id: userId,
//             Login_device_type: deviceType,
//             source_id: sourceId,
//             source_type: sourceType,
//             dislike_status: status,
//         }, {
//             headers: getItemToken('access_token') || {
//                 'guestverfiykey': "WebVodWebnexs",
//                 'Content-Type': 'application/json',
//             }
//         });
//         // console.log(response?.data)
//         if (response.data.status) {
//             return response?.data;
//         } else {
//         }
//         return response.data.status;
//     } catch (error) {
//         console.error(error);
//         throw error;
//     }
// };


const LikeAction = async (userId, userType, deviceType, sourceId, sourceType, status, accessHeader) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_Baseurl}/Front-End/Like-Update`, {
            Login_user_type: userType,
            Login_user_id: userId,
            Login_device_type: deviceType,
            source_id: sourceId,
            source_type: sourceType,
            like_status: status,
        }, {
            headers: getItemToken('access_token') || {
                'guestverfiykey': "WebVodWebnexs",
                'Content-Type': 'application/json',
            }
        });

        if (response.data?.status) {
            toast.success(t(response.data?.message || "Liked successfully"));
        } else {
            toast.error(t(response.data?.message || "Like failed"));
        }

        return response?.data;

    } catch (err) {
        const errorMessage = err.response?.data?.message || 'An error occurred';
        toast.error(t(errorMessage));
        throw err;
    }
};

const disLikeAction = async (userId, userType, deviceType, sourceId, sourceType, status) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_Baseurl}/Front-End/Dislike-Update`, {
            Login_user_type: userType,
            Login_user_id: userId,
            Login_device_type: deviceType,
            source_id: sourceId,
            source_type: sourceType,
            dislike_status: status,
        }, {
            headers: getItemToken('access_token') || {
                'guestverfiykey': "WebVodWebnexs",
                'Content-Type': 'application/json',
            }
        });

        if (response.data?.status) {
            toast.success(t(response.data?.message || "Disliked successfully"));
        } else {
            toast.error(t(response.data?.message || "Dislike failed"));
        }

        return response.data;

    } catch (error) {
        const errorMessage = error.response?.data?.message || 'An error occurred';
        toast.error(t(errorMessage));
        throw error;
    }
};

const watchLaterAction = async (userId, userType, deviceType, sourceId, sourceType, status) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_Baseurl}/Front-End/Watchlater-Update`, {
            Login_user_type: parseInt(getItem('role'), 10) || 9,
            Login_user_id: parseInt(getItem('user_id'), 10) || null,
            Login_device_type: "web",
            source_id: sourceId,
            source_type: sourceType
        }, {
            headers: getItemToken('access_token') || {
                'guestverfiykey': "WebVodWebnexs",
                'Content-Type': 'application/json',
            }
        });
        if (response.data.status) {
            toast.success(t(response?.data?.message || (response?.data?.WatchLater_data != null ? 'Video has been moved to Watch Later' : "Video has been removed from Watch Later")));
            return response?.data;
        }
        else { }
        return response.data.status;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

const wishListAction = async (userId, userType, deviceType, sourceId, sourceType, accessHeader) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_Baseurl}/Front-End/Wishlist-Update`, {
            Login_user_type: parseInt(getItem('role'), 10) || 9,
            Login_device_type: "web",
            Login_user_id: parseInt(getItem('user_id'), 10) || null,
            source_id: sourceId,
            source_type: sourceType
        }, {
            headers: getItemToken('access_token') || {
                'guestverfiykey': "WebVodWebnexs",
                'Content-Type': 'application/json',
            }
        });
        if (response.data.status) {
            toast.success(t(response?.data?.message || (response?.data?.wishlist_data != null ? "Video has been moved to Watchlist" : "Video has been removed from Watchlist")));
            return response?.data
        }
        else { }
        return response.data.status;
    } catch (error) {
        console.error(error);
    }
};
const myListAction = async (userId, userType, deviceType, sourceId, sourceType, status) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_Baseurl}/Front-End/MyList-Update`, {
            Login_user_type: parseInt(getItem('role'), 10) || 9,
            Login_device_type: "web",
            Login_user_id: parseInt(getItem('user_id'), 10) || null,
            source_id: sourceId,
            source_type: sourceType
        }, {
            headers: getItemToken('access_token') || {
                'guestverfiykey': "WebVodWebnexs",
                'Content-Type': 'application/json',
            }
        });
        if (response.data.status) {
            response?.data?.Mylist_data != null ? toast.success(t("Item has been moved to My List")) : toast.success(t("Item has been removed from My List"));
            return response?.data;
        }
    } catch (error) { console.error(error); }
};
const recentViewAction = async (userId, userType, deviceType, sourceId, sourceType, status) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_Baseurl}/Front-End/Recent-views-Update`, {
            Login_user_type: parseInt(getItem('role'), 10) || 9,
            Login_device_type: "web",
            Login_user_id: parseInt(getItem('user_id'), 10) || null,
            source_id: sourceId,
            source_type: sourceType
        }, {
            headers: getItemToken('access_token') || {
                'guestverfiykey': "WebVodWebnexs",
                'Content-Type': 'application/json',
            }
        });
        if (response.data.status) {
            response?.data?.RecentView_data != null ? toast.success(t("Item has been moved to Recent View")) : toast.success(t("Item has been removed from Recent View"));
            return response?.data;
        }
    } catch (error) {
        console.error(error);
    }
};
const themeToggleMethod = async (themeModeNumber) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_Baseurl}/Front-End/theme-mode`, {
            Login_user_type: parseInt(getItem('role'), 10) || 9,
            Login_user_id: parseInt(getItem('user_id'), 10) || null,
            Login_device_type: "web",
            theme_mode: themeModeNumber
        }, { headers: getItemToken('access_token') || null });
        return response.data;
    } catch (error) {
        console.error("Error in themeToggleMethod:", error);
        throw error;
    }
};

const currentIpAddressDetails = async () => {
    try {
        const responseIP = await axios.get(`${process.env.REACT_APP_API_IP_Location}`);
        return responseIP?.data;
    } catch (error) {
        console.error('Error fetching IP address details:', error);
        return null;
    }
};
const PDFGenerator = (data, fileName) => {
    const doc = new jsPDF();
    const PDFColumns = ["INDEX", "ID", "TITLE", "UPLOADED BY", "STATUS", "BANNER", "UPLOAD ON"];
    const database = data?.map((item, index) => [
        index + 1,
        item?.id,
        item?.title,
        item?.uploaded_by,
        item?.active,
        item?.banner,
        item?.upload_on
    ]);
    doc.autoTable({
        startY: 10,
        startX: 10,
        head: [PDFColumns],
        body: database,
        margin: { top: 5, right: 5, bottom: 5, left: 5 },
        styles: {
            cellPadding: 3,
            fontSize: 10,
            lineColor: [240, 240, 240],
            lineWidth: 0.1,
        }
    });
    doc.save(`${fileName}.pdf`);
};

const XLSXGenerator = (data, fileName) => {
    const extractedData = data.map((item, index) => {
        return {
            Index: index + 1,
            ID: item?.id,
            TITLE: item?.title,
            UPLOADED_BY: item?.uploaded_by,
            STATUS: item?.active,
            BANNER: item?.banner,
            UPLOAD_ON: item?.upload_on
        };
    });
    var wb = XLSX.utils.book_new(), ws = XLSX.utils.json_to_sheet(extractedData);
    XLSX.utils.book_append_sheet(wb, ws, "MySheet");
    XLSX.writeFile(wb, `${fileName}.xlsx`);
};

const CSVColumn = [
    { label: "ID", key: "id" },
    { label: "TITLE", key: "title" },
    { label: "UPLOADED BY", key: "uploaded_by" },
    { label: "STATUS", key: "active" },
    { label: "BANNER", key: "banner" },
    { label: "UPLOAD ON", key: "upload_on" },
];


export { calculateTotalTime, URLGenerater, URLDashRemover, getSourceFromURL, LogOut, capsFirstLetter, LikeAction, disLikeAction, watchLaterAction, wishListAction, myListAction, recentViewAction, PDFGenerator, XLSXGenerator, CSVColumn, themeToggleMethod, capitalizeFirstLetter, currentIpAddressDetails, formatDuration }
